import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'caret-left-right', 'CaretLeftRight', [["path",{"d":"M14 18l6 -6l-6 -6v12"}],["path",{"d":"M10 18l-6 -6l6 -6v12"}]]);